import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { mcpGatewaysQueryOptions } from "@/app/mcp-gateways/api/get-mcp-gateways";
import { MCPGatewaysListSkeleton } from "@/app/mcp-gateways/components/mcp-gateways-list-skeleton";
import { MCPGatewayList } from "@/app/mcp-gateways/list";
import {
  mcpGatewaysSearchDefaults,
  mcpGatewaysSearchSchema,
} from "@/app/mcp-gateways/search-params";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways"
)({
  validateSearch: zodValidator(mcpGatewaysSearchSchema),
  search: {
    middlewares: [stripSearchParams(mcpGatewaysSearchDefaults)],
  },
  component: () => (
    <Suspense fallback={<MCPGatewaysListSkeleton />}>
      <MCPGatewayList />
    </Suspense>
  ),
  beforeLoad(ctx) {
    ctx.context.queryClient.prefetchQuery(
      mcpGatewaysQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
  loader: () => ({
    crumb: "MCP Gateways",
  }),
});
